import React, { Fragment, useContext, useEffect, useState } from 'react';

import proyectoContext from '../../context/proyectos/proyectoContext';
import tareaContext from '../../context/tareas/tareaContext';
import AuthState from '../../context/autenticacion/authContext';

import Descripcion from './Descripcion';

import { TiArrowLeftThick } from "react-icons/ti";
import { BsTrash } from "react-icons/bs";
import { FaRegEdit } from "react-icons/fa";
import { MdCheck, MdClose } from "react-icons/md";
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import Swal from 'sweetalert2';

const VerTarea = () => {
    // Extraer si un proyecto está activo
    const proyectosContext = useContext(proyectoContext);
    const { proyecto, obtenerUltimosCambios, guardarUltimoCambio } = proyectosContext;

    // Obtener la funcion del context de tarea
    const tareasContext = useContext(tareaContext);
    const {
        tareaactual,
        descripcionestarea,
        cambiarEstado,
        tareaEliminar,
        seleccionarTarea,
        verTarea,
        tareaActual,
        limpiarDescripcion,
        formularioDescripcion 
    } = tareasContext;

    // Extraer usuario logeado
    const authState = useContext(AuthState);
    const { usuario } = authState;
    
    // State para guardar la tarea
    const [ tarea, guardarTarea ] = useState({
        nombre: '',
        para: ''
    });
    
    // Extraer el proyecto
    const [ proyectoActual ] = proyecto;

    // Effect que detecta si hay una tarea seleccionada
    useEffect(() => {
        if(tareaactual !== null) {
            guardarTarea(tareaactual);
        }else {
            guardarTarea({
                nombre: '',
                para: ''
            });
        }
    }, [tareaactual]);

    // Funcion que limpia el formulario de descripcion y vuelve a lista de tareas
    const handleVolver = () => {
        verTarea(false);
        limpiarDescripcion();
        formularioDescripcion(false);
        tareaActual('');
    }

    // Funcion que cambia el formulario y permite editar la tarea actual
    const handleEditar = () => {
        seleccionarTarea(tarea);
        formularioDescripcion(false);
    }

    // Funcion que elimina la tarea y cambia el formulario
    const handleEliminar= () => {
        Swal.fire({
            title: '¿Estás seguro?',
            text: "Un tarea que se elimina no se puede recuperar.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2f3848',
            cancelButtonColor: '#be3434',
            confirmButtonText: 'Si, ¡eliminalo!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                tareaEliminar(tarea._id, proyectoActual._id, true);
                formularioDescripcion(false);
                guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Eliminó la tarea');
                obtenerUltimosCambios(proyectoActual._id); // Filtra los ultimos cambios
            }
        });
    }

    // Funcion que ejecuta al cambiar estado
    const handleEstado = () => {
        cambiarEstado(tarea);
        guardarUltimoCambio(proyectoActual._id, 'Tarea', tarea.nombre, 'Actualizó el estado');
        obtenerUltimosCambios(proyectoActual._id); // Filtra los ultimos cambios
    }

    return ( 
        <Fragment>
            <div className="acciones-ver-tarea">
                <div>
                    <button 
                        type="button"
                        className="btn-volver"
                        onClick={() => handleVolver()}
                    >
                        <TiArrowLeftThick />
                    </button>
                </div>
                
                { usuario ? (
                    usuario.rol === 'Administrador' ? (
                        <div>
                            <button
                                type="button"
                                className="btn btn-editar-tarea"   
                                onClick={() => handleEditar()}
                            >
                                <FaRegEdit />
                            </button>
                            
                            <button
                                type="button"
                                className="btn btn-eliminar-tarea"
                                onClick={() => handleEliminar()}
                            >
                                <BsTrash />
                            </button>
                        </div>
                    ) : null
                ) : null }

            </div>
            
            <h2>Tarea: {tarea.nombre}</h2>

            <ul className="vista-detalles">
                <div className="info-principal">
                    <li className="info-pequeña">
                        <p><span>Nombre:</span> {tarea.nombre}</p>
                    </li>
                    <li className="info-pequeña">
                        <p><span>Para:</span> {tarea.para}</p>
                    </li>
                </div>
                <div className="info-principal">
                    <li className="info-pequeña">
                        <p><span>Fecha de creación:</span> {tarea.fechaCreacion}</p>
                    </li>
                    <li className="info-pequeña">
                        <p>
                            <span>Estado: </span>
                        </p>
                        {tarea.estado
                            ? 
                                (
                                    <button
                                        type="button"
                                        className="completo"
                                        onClick={() => handleEstado()}
                                    >
                                        <MdCheck />
                                    </button>
                                    
                                )
                            :
                                (
                                    <button
                                        type="button"
                                        className="incompleto"
                                        onClick={() => handleEstado()}
                                    >
                                        <MdClose />
                                    </button>
                                )
                        }
                    </li>
                </div>
            </ul>

            <section className="descripciones-tarea">
                <h3>Descripciones: </h3>
                <ul className="listado-descripciones">
                    {descripcionestarea.length === 0
                        ? 
                            <li className="descripcion"><p>No hay descripciones</p></li>
                        : 
                        <TransitionGroup>
                            {descripcionestarea.map(descripcion => (
                                <CSSTransition
                                    key={descripcion._id}
                                    timeout={200}
                                    classNames="tarea"
                                >
                                    <Descripcion
                                        tarea={tarea}
                                        descripcion={descripcion}
                                    />
                                </CSSTransition>
                            ))}
                        </TransitionGroup>
                    }
                </ul>
            </section>
        </Fragment>
    );
}
 
export default VerTarea;